import React, { useContext, useState } from "react";
import "./index.css";
import { AppContext } from "../../context/AppContext";

export default function StudentForm() {
  const { setModalShow } = useContext(AppContext);
  const [isSubmitForm, setFormSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    student_name: "",
    phone_number: "",
    email: "",
    state: "",
    education: "",
    otherEducation: "",
    course: "",
    agreed: false,
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};

    if (!formData.student_name.trim()) {
      errs.student_name = "Name is required";
    } else if (!/^[A-Za-z ]{3,}$/.test(formData.student_name.trim())) {
      errs.student_name = "Name should be at least 3 letters";
    }

    if (!formData.phone_number.trim()) {
      errs.phone_number = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone_number.trim())) {
      errs.phone_number = "Phone must be exactly 10 digits";
    }

    if (!formData.email.trim()) {
      errs.email = "Email is required";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email.trim())) {
      errs.email = "Invalid email format";
    }

    if (!formData.state) {
      errs.state = "Please select your state";
    }

    if (!formData.education) {
      errs.education = "Please select your education";
    }

    if (!formData.course) {
      errs.course = "Please select your course";
    }

    if (!formData.agreed) {
      errs.agreed = "You must agree to the terms";
    }

    setErrors(errs);

    return Object.keys(errs).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🔷 Use your validate() function
    const isValid = validate();
    if (!isValid) {
      return; // if validation fails, stop here
    }

    setLoading(true);

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbw8EQKJzfny_CkzR_wF-FzDIh3B5sgiJ8WGK847ljwE38QjaqtF2CXf3jXuj1MT03_y/exec",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
          mode: "no-cors",
        }
      );

      setFormData({
        student_name: "",
        phone_number: "",
        email: "",
        education: "",
        otherEducation: "",
        course: "",
        agreed: false,
        state: "",
      });

      setFormSubmit(true);
      setErrors({});
    } catch (err) {
      console.error("❌ Submission failed", err);
    } finally {
      setLoading(false);
      setTimeout(() => {
        setModalShow(false);
      }, 3000);

      // alert("Submitted Successfully 🎉");
    }
  };

  return (
    <form
      className="student-form-card"
      onSubmit={handleSubmit}
      style={{ maxWidth: "100%", margin: "0 auto" }}
    >
      <div className="d-flex flex-column align-items-center">
        <div className="d-flex align-items-center">
          <img
            className="company-logo"
            src="https://creative-croquembouche-17baf9.netlify.app/image.png"
            alt="company-logo"
          />
          <h1 className="nav-heading">
            IBIX Qodify
            <br />
            <span className="nav-tech-text">Technologies</span>
          </h1>{" "}
        </div>
      </div>
      {isSubmitForm ? (
        <div className="text-center">
          <img
            src="https://iqteche.in/static/media/wl_client_images/b83582403ca14311ad1e09fe9df3ba66.png"
            alt="submit-form-img"
            className="thumb-icon"
          />
          <h3>Form Submitted Successfully! 🎉</h3>
          <p>Our Career Expert Will Contact you.</p>
        </div>
      ) : (
        <div>
          <h2>Talk to Our Career Counsellor Expert</h2>

          <div>
            <label>Student Name:</label>
            <br />
            <input
              type="text"
              name="student_name"
              value={formData.student_name}
              onChange={handleChange}
            />
            {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
          </div>

          <div>
            <label>Phone Number:</label>
            <br />
            <input
              type="tel"
              name="phone_number"
              value={formData.phone_number}
              onChange={handleChange}
            />
            {errors.phone && <p style={{ color: "red" }}>{errors.phone}</p>}
          </div>

          <div>
            <label>Email:</label>
            <br />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
          </div>

          <div>
            <label>Select your State:</label>
            <br />
            <select name="state" value={formData.state} onChange={handleChange}>
              <option value="">--Select State--</option>
              <option value="Andhra Pradesh">Andhra Pradesh</option>
              <option value="Telangana">Telangana</option>
              <option value="Karnataka">Karnataka</option>
              <option value="Kerala">Kerala</option>
              <option value="Tamilnadu">Tamilnadu</option>
            </select>
            {errors.state && <p style={{ color: "red" }}>{errors.state}</p>}
          </div>

          <div>
            <label>Education:</label>
            <br />
            <select
              name="education"
              value={formData.education}
              onChange={handleChange}
            >
              <option value="">--Select--</option>
              <option value="High School">High School</option>
              <option value="Degree">Degree</option>
              <option value="B.Tech">B.Tech</option>
              <option value="12th/Diploma">12th/Diploma</option>
              <option value="Other">Other</option>
            </select>
            {errors.education && (
              <p style={{ color: "red" }}>{errors.education}</p>
            )}
          </div>

          {formData.education === "Other" && (
            <div>
              <label>Mention Education:</label>
              <br />
              <input
                type="text"
                name="otherEducation"
                value={formData.otherEducation}
                onChange={handleChange}
              />
            </div>
          )}

          <div>
            <label>Select the course you're seeking details on:</label>
            <br />
            <select
              name="course"
              value={formData.course}
              onChange={handleChange}
            >
              <option value="">--Select--</option>
              <option value="Full Stack">Full Stack</option>
              <option value="Data Science">Data Science</option>
              <option value="AI & ML">AI & ML</option>
              <option value="Cyber Security">Cyber Security</option>
              <option value="Tech Tools">Tech Tools</option>
            </select>
            {errors.course && <p style={{ color: "red" }}>{errors.course}</p>}
          </div>

          <div>
            <label>
              <input
                type="checkbox"
                name="agreed"
                checked={formData.agreed}
                onChange={handleChange}
              />
              I have filled the correct info and agree to the T&C
            </label>
            {errors.agreed && <p style={{ color: "red" }}>{errors.agreed}</p>}
          </div>

          <button type="submit"> {loading ? "Submitting..." : "Submit"}</button>
        </div>
      )}
    </form>
  );
}
